import { useToast } from 'common/hooks/useToast';
import useTranslation from 'common/hooks/useTranslation';
import { useLazyGetSubmissionCurriculumQuery } from 'common/slices/submissionApi.slice';
import { useEffect, useState } from 'react';

export const useLazyCvUrl = ({ submissionSlug }) => {
  const toast = useToast();
  const { t } = useTranslation('offers\\details');
  const [trigger, { isFetching }] = useLazyGetSubmissionCurriculumQuery();
  const [cvUrl, setCvUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setCvUrl(null);
    setLoading(true);
  }, [submissionSlug]);

  const fetchCvUrl = async () => {
    try {
      const data = await trigger({ submissionSlug }, true).unwrap();
      setCvUrl(data);
      return data;
    } catch (err) {
      if (err?.status === 403) {
        toast.newToast('negative', t('toasts.forbidden'));
      } else {
        const detail = err?.data?.errors[0]?.detail;
        toast.newToast('negative', detail || t('toasts.something-wrong'));
      }
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    fetchCvUrl,
    cvUrl,
    isLoadingCurriculum: loading,
    isFetchingCurriculum: isFetching,
  };
};
